import * as R from 'ramda'

export const removeNilAndEmpty = R.pipe(
  R.reject(R.isNil),
  R.reject(R.isEmpty)
)
